import React, { useRef } from "react";
import Sketch from "react-p5";
import { useReactToPrint } from "react-to-print";
import Yurt from "./entities/yurt";
import { title } from "./entities/title";
import Stack from "./entities/stacks/stack";
import { createStack } from "./entities/stacks/createStack";
import styled from "styled-components";
// import {useState} from "react"

let yurt = null;
let stack = null;

const StackDistribution = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 20px;
  input {
    border: none;
    background: lightgrey;
  }
`;

const NumberOfStacks = styled.input``;

const Print = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  padding: 10px;
  z-index: 999;
  cursor: pointer;
  &:hover {
    color: black;
  }
`;

const Container = styled.div`
  position: relative;
`;

const CanvasToPrint = ({
  yurtTrait,
  handleWallChange,
  wallTrait,
  pixels,
  handleYurtChange,
  edit,
  stackEdit,
  stackArray,
  setStackArray,
  setTabIndex,
  stackHeights,
}) => {
  const clearStackArray = () => {
    setStackArray([]);
  };

  // const [stackInputs, setStackInputs] = useState(4)

  const drawMouseLines = (p5) => {
    if (
      p5.mouseX > 0 &&
      p5.mouseY > 0 &&
      p5.mouseX < p5.width &&
      p5.mouseY < p5.height
    ) {
      p5.push();
      p5.strokeWeight(0.2);
      p5.line(p5.mouseX, 0, p5.mouseX, p5.height);
      p5.line(0, p5.mouseY, p5.width, p5.mouseY);
      p5.pop();
    }
  };

  const handleStackArray = (x) => {
    let newStack = [...stackArray];
    let dupl = false;
    newStack.forEach((e, i) => {
      if (e === x) {
        newStack.splice(i, 1);
        dupl = true;
      }
    });
    if (!dupl) {
      newStack.push(x);
    }
    setStackArray(newStack);
  };

  const setup = (p5) => {
    var canvasDiv = document.getElementById("main-canvas");
    var width = canvasDiv.offsetWidth;
    var sketch = p5.createCanvas(width, 1200);
    sketch.parent("main-canvas");
  };

  const draw = (p5) => {
    p5.background(255);
    p5.angleMode(p5.DEGREES);
    p5.cursor("default");
    var canvasDiv = document.getElementById("main-canvas");
    var width = canvasDiv.offsetWidth;
    p5.resizeCanvas(width, 1200);

    yurt = new Yurt(p5, yurtTrait, width, handleWallChange, wallTrait);

    yurt.turn(p5, yurtTrait.placement);

    p5.mouseClicked = () => {
      if (edit) {
        yurt.clicked(p5, wallTrait);
      } else if (stackEdit) {
        yurt.stackEditClicked(p5, wallTrait, handleStackArray);
      } else {
        yurt.travelClicked(p5, setTabIndex);
      }
    };

    if (!edit && !stackEdit) {
      yurt.hover(p5, "lightgrey");
    }

    if (stackEdit) {
      yurt.hover(p5, "lightgrey");
      yurt.stackEditRender(p5, wallTrait, stackArray);
      stack = new Stack(
        p5,
        createStack(yurtTrait.size, wallTrait, stackArray, stackHeights),
        wallTrait,
        handleYurtChange
      );
      stack.render();
    } else {
      stack = new Stack(p5, yurtTrait.stack, wallTrait, handleYurtChange);
      stack.render();
      if (edit) {
        drawMouseLines(p5);
        yurt.hover(p5, "#FFD580");
      }
      yurt.render(p5, wallTrait, edit);
      title(p5, yurtTrait, width, pixels);
    }
  };
  return (
    <div id="main-canvas">
      <button
        style={{ display: stackEdit ? "" : "none" }}
        id="project-clear-stack"
        className="btn-outline-warning"
        onClick={clearStackArray}
      >
        Clear
      </button>
      <StackDistribution>
        <NumberOfStacks></NumberOfStacks>
      </StackDistribution>
      <Sketch setup={setup} draw={draw} />
    </div>
  );
};

const Canvas = ({
  yurtTrait,
  handleWallChange,
  wallTrait,
  pixels,
  handleYurtTraitChange,
  editYurt,
  stackEdit,
  stackArray,
  setStackArray,
  setTabIndex,
  stackHeights,
}) => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  return (
    <Container>
      <Print
        onClick={handlePrint}
        style={{ display: editYurt || stackEdit ? "none" : "" }}
      >
        Print
      </Print>

      <div ref={componentRef} className="canvas-container">
        <CanvasToPrint
          yurtTrait={yurtTrait}
          handleWallChange={handleWallChange}
          wallTrait={wallTrait}
          pixels={pixels}
          handleYurtChange={handleYurtTraitChange}
          edit={editYurt}
          stackEdit={stackEdit}
          stackArray={stackArray}
          setStackArray={setStackArray}
          setTabIndex={setTabIndex}
          stackHeights={stackHeights}
        />
      </div>
    </Container>
  );
};

export default Canvas;
